import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { DashboardService } from './dashboard.service';
import { CommonDashboardService } from './common-dashboard.service';
import { CommonDashboardFilterResponse } from './types';

@Injectable({
  providedIn: 'root'
})
export class CampaignsFiltersResolverService implements Resolve<any> {

  private dashboardService = inject(DashboardService);
  private commonDashboardService = inject(CommonDashboardService);

  constructor() {}

  resolve(route: ActivatedRouteSnapshot): Observable<CommonDashboardFilterResponse> | Observable<any> {
    if (this.dashboardService.commonFiltersResponse) {
      return of(this.dashboardService.commonFiltersResponse);
    }
    return this.commonDashboardService.getFilters()
    .pipe(
        tap((commonFilters) => {
          this.dashboardService.setInitialCommonFilters(commonFilters);
        })
      );
  }
}
